/**
 * Marketing-email opt-in.
 *
 * NOTE ON CONSENT: this defaults to checked (opt-out), and the server subscribes with
 * status 'subscribed' at session creation -- so an abandoned checkout still results in a
 * subscription, with no double opt-in. That is workable for US-only traffic but would need
 * revisiting for EU/UK (GDPR) or Canadian (CASL) audiences. Flagged rather than changed,
 * since it is a business decision.
 */
export default function MailchimpOptIn({ checked, onChange }) {
  return (
    <div className="flex items-start justify-center gap-3">
      <input
        type="checkbox"
        id="mailchimpOptIn"
        name="mailchimpOptIn"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-4 h-4 rounded border-2 border-gray-300 text-primary-600 focus:border-primary-500 focus:ring-primary-500"
      />
      <label htmlFor="mailchimpOptIn" className="text-sm text-gray-700 leading-relaxed">
        Please send me helpful industry news and tips on how I can grow my business.
      </label>
    </div>
  );
}
